import SessionService from './sessionService';

export default class UserSessionService {
  static _instance = new SessionService(
    window.sessionStorage,
    (storageProvider, key, value) => {
      storageProvider.setItem(key, JSON.stringify(value));
    },
    (storageProvider, key) => {
      const value = storageProvider.getItem(key);
      return value ? JSON.parse(value) : null;
    },
    (storageProvider, key) => {
      storageProvider.removeItem(key);
    },
    process.env.NODE_ENV === 'development' ? '_user' : '_u',
    process.env.NODE_ENV === 'development' ? 'impersonated' : 'ui',
    process.env.NODE_ENV === 'development' ? 'token' : 't',
    process.env.NODE_ENV === 'development' ? 'session' : 's',
    process.env.NODE_ENV === 'development' ? 'user' : 'u',
    process.env.NODE_ENV === 'development' ? 'tenant' : 'te'
  );

  static get storageProvider() {
    return sessionStorage;
  }

  static saveSession(token, session, user, tenant, impersonated) {
    this._instance.saveSession(token, session, user, tenant, impersonated);
  }

  static removeSession() {
    this._instance.removeSession();
  }

  static getSession() {
    return this._instance.getSession();
  }

  static getToken() {
    return this._instance.getToken();
  }

  static saveUnImpersonationToken(token) {
    this._instance.saveUnImpersonationToken(token);
  }

  static isImpersonated() {
    return this._instance.isImpersonated();
  }
}
